export const Z = {
  dropdown: 200,
  globalNav: 100,
  pageLoadingBar: 300,
  popover: 75,
  toasts: 150,
  footer: 1,
}
